// import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

import { ServiceDeliveryRepository } from "../domain/ServiceDeliveryRepository";

export class RegenerateInvoiceCommand {
  constructor(
    private readonly sd_repo: ServiceDeliveryRepository,
  ) {}

  async run(charge_id): Promise<{ [key: string]: string; }> {

    return await this.sd_repo.regenerate_invoice(charge_id)

    // this.frontend.$set(item, 'running_job_id', response.job_id);
    // setTimeout(()=>this.frontend.is_job_done(response.job_id),1000)
    // let args = {
    //   cmd_name:"create.invoice",
    //   service_charge_id:charge_id
    // };
    // try {
    //   return this.dispatcher.dispatch('create.invoice', args);
    // } catch(error) {
    //   console.error('Error al regenerar Factura', error)
    // }
  }
}